import React from 'react';
import { Link } from 'react-router-dom';
import './PageBreadcrumb.scss';

type BreadcrumbItem = { label: string; path: string };

export const PageBreadcrumb = ({ title, parents = [] }: { title: string; parents?: BreadcrumbItem[] }) => (
  <nav className='page-breadcrumb' aria-label='Đường dẫn trang'>
    <ol>
      <li className='breadcrumb-home-item'><Link className='breadcrumb-home' to='/overview' aria-label='Tổng quan' title='Tổng quan'><svg viewBox='1.75 1.75 20.5 20.5' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'><path d='M3 10.5 12 3l9 7.5M5 9v12h5v-7h4v7h5V9' /></svg></Link></li>
      {parents.map((item) => <React.Fragment key={item.path}>
        <li className='breadcrumb-separator' aria-hidden='true'><svg viewBox='0 0.5 6 11' fill='none' stroke='currentColor' strokeWidth='1' strokeLinecap='round'><path d='m1 11 4-10' /></svg></li>
        <li><Link className='breadcrumb-parent' to={item.path}>{item.label}</Link></li>
      </React.Fragment>)}
      <li className='breadcrumb-separator' aria-hidden='true'><svg viewBox='0 0.5 6 11' fill='none' stroke='currentColor' strokeWidth='1' strokeLinecap='round'><path d='m1 11 4-10' /></svg></li>
      <li aria-current='page'><h1>{title}</h1></li>
    </ol>
  </nav>
);
